import 'edge/quoteandbind/common/models/Submission';

export default ['JsonRPCService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', function (JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var endpoint = endpointConfig.bopCoverablesEndpoint;
    var xCenterRoute = xCenterRouteConfig;

    return {
        addBOPLocation: function addBOPLocation(quoteID, bopLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'addLocation', [quoteID, bopLocation, sessionUUID]);
        },
        updateBOPLocation: function updateBOPLocation(quoteID, bopLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateLocation', [quoteID, bopLocation, sessionUUID]);
        },
        removeBOPLocation: function removeBOPLocation(quoteID, bopLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'removeLocation', [quoteID, bopLocation, sessionUUID]);
        },
        addBOPBuilding: function addBOPBuilding(quoteID, bopLocationId, bopBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'addBuilding', [quoteID, bopLocationId, bopBuilding, sessionUUID]);
        },
        updateBOPBuilding: function updateBOPBuilding(quoteID, bopLocationId, bopBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateBuilding', [quoteID, bopLocationId, bopBuilding, sessionUUID]);
        },
        removeBOPBuilding: function removeBOPBuilding(quoteID, bopLocationId, bopBuildingId, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'removeBuilding', [quoteID, bopLocationId, bopBuildingId, sessionUUID]);
        },
        updateBOPBuildingCoverages: function updateBOPBuildingCoverages(quoteID, bopLocationId, bopBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateBuildingCoverages', [quoteID, bopLocationId, bopBuilding, sessionUUID]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/bop/services/BOPCoverablesService.js
// module id = 2110
// module chunks = 0